<template>
    <el-dialog class="eval-dialog"
               :visible.sync="isShow"
               title="此申请是否用于本年度继续教育报名"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="true"
               width="460px"
               center>
         <div class="form_content" >
            <el-form ref="form" :model="form"  class="form">
              <el-radio-group v-model="form.enroll_id">
                <el-radio :label="0"  @change="changeCheck(0)">否</el-radio>
                <el-radio :label="1" @change="changeCheck(1)">是</el-radio>
              </el-radio-group>
            </el-form>
            <div class="sure" >
                <el-button type="primary" @click="sure_select" :loading="loading" :disabled="loading">
                    提交
                </el-button>
              <el-button type="danger"
                @click="cancel">取消
              </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {editEnterEnrollStatus} from "@/api/ab_signup/api";
    export default {
        name: "edit-enter-enroll",
        data(){
          return{
              form:{
                  record_id:this.recordId,
                  enroll_id:this.enrollId,
              },
              loading:false
          }
        },
      props:{
        showdialog:{
          type:Boolean,
          required:true,
        },
        enrollId:{
          type:Number,
          required:true,
        },
        recordId:{
          type:Number,
          required:true,
        }
      },
        methods:{
          changeCheck(check){
            this.form.enroll_id = check;
          },
            sure_select(){
                this.loading=true;
                this.$refs['form'].validate(valid=>{
                    if (valid){
                      editEnterEnrollStatus({
                        enroll_id:this.form.enroll_id,
                        record_id:this.recordId
                        }).then(res=>{
                            if (Number(res.data.status)===0){
                                this.loading=false;
                                this.$message.success('修改成功');
                                this.$emit('hideTips',false,true)
                            }else{
                                this.$message.error(res.data.msg)
                                this.loading=false;
                            }
                        }).catch(err=>{
                            console.log(err);
                            this.loading=false;
                        })
                    }else{
                        this.$message.error('出错了~');
                        this.loading=false
                    }
                })
            },
          cancel(){
            this.isShow = false;
          }
        },
        computed:{
          isShow: {
                get(){
                    return this.showdialog;
                },
                set(bool) {
                  this.$emit("hideTips", bool, false);
                }
          },
//          record_id() {
//            return this.recordId
//          },
//          enroll_id() {
//            return this.enrollId
//          }
        }
    }
</script>

<style scoped lang="stylus">
    .form_content
        .form
          text-align: center;
        .sure
            text-align: center;
            margin-top: 40px
</style>
